import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
  ValidationErrors,
  AbstractControl,
} from '@angular/forms';
import {
  MatDialog,
  MAT_DIALOG_DATA,
  MatDialogRef,
} from '@angular/material/dialog';
import { AppConstants } from 'src/app/shared/constants/app.contants';
import { UserService } from '../../../../services/user/user.service';
import { AlertService, MessageSeverity } from '../../../services/alert.service';
import { EmitterService } from '../../../services/emitter.service';
import { MessageModalComponent } from '../message/message-modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { AdminService } from '../../../../services/admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { RoleService } from 'src/app/services/role/role.service';
import { MatPaginator, MatTableDataSource } from '@angular/material';
import { EnterpriseService } from 'src/app/services/enterprise/enterprise.service';
import { UserNewAssingModalComponent } from './user-new-assing-modal/user-new-assing-modal.component';
import { decryptData } from 'src/app/shared/helpers/decrypt';
import { Error as ErrorModel } from 'src/app/models/error';

@Component({
  selector: 'user-modal',
  styleUrls: ['./user-modal.component.css'],
  templateUrl: 'user-modal.component.html',
})
export class UserModalComponent implements OnInit {
  userForm: FormGroup;
  title: string;
  hide = true;
  repeatHide = true;
  loading: boolean = false;
  roles = [];
  showEdit: boolean = false;
  isAdminGys: boolean = false;
  sessionUserId: string;
  roleSelect = 0;
  headquarterSelect = 0;
  headquarters = [];
  color1: string;
  color2: string;
  showAssignTable: boolean;
  isImageSizeCorrect = true;
  userPermissionMaster: number;
  //TABLA
  dataSource = new MatTableDataSource();
  displayedColumns: string[] = ['enterprise', 'headquarter', 'role', 'action'];
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  items = [];
  photoFile: File;
  photoPreview: string;

  constructor(
    public dialogRef: MatDialogRef<UserModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: FormBuilder,
    private spinner: NgxSpinnerService,
    public dialog: MatDialog,
    private userService: UserService,
    private alertService: AlertService,
    private emitterService: EmitterService,
    private adminService: AdminService,
    private roleService: RoleService,
    //TABLA
    private enterpriseService: EnterpriseService
  ) {
    this.userPermissionMaster = +decryptData(localStorage.getItem(AppConstants.Session.USER_MASTER_PERMISSION));
    this.showAssignTable = false; //data.showAssignTable;
  }

  ngOnInit() {
    // console.log('data', this.data);
    this.color1 = localStorage.getItem(AppConstants.Session.THEME_COLOR1);
    this.color2 = localStorage.getItem(AppConstants.Session.THEME_COLOR2);
    this.isAdminGys =
      +localStorage.getItem(AppConstants.Session.ROLID) ==
        AppConstants.UserRole.AdministradorGyS ||
      +localStorage.getItem(AppConstants.Session.ROLID) ==
        AppConstants.UserRole.UsuarioGyS
        ? true
        : false;
    this.sessionUserId = localStorage.getItem(AppConstants.Session.USERID);
    this.headquarters = this.data.headquarters;
    this.createForm();
    this.setValues();
    this.getRoles();

    this.photoPreview = '../../../../../../assets/images/user-noimage.png';
  }

  ngAfterViewInit() {
    //TABLA
    if (this.showAssignTable) {
      this.dataSource.paginator = this.paginator;
      this.paginator._intl.itemsPerPageLabel = '';
      this.list();
    }
  }

  //USUARIOS ASIGNADOS -------------------------------------------------------------------------------------------
  createForm() {
    this.showEdit =
      this.data.action == AppConstants.OperationType.UPDATE ? true : false;
    this.userForm = this.formBuilder.group({
      // documentNumber: ['', [Validators.required, Validators.minLength(8), Validators.maxLength(8)]],
      email: [
        '',
        [Validators.required, Validators.maxLength(100), Validators.email],
      ],
      names: [
        '',
        [
          Validators.required,
          Validators.maxLength(30),
          this.noWhitespaceValidator,
        ],
      ],
      lastName: [
        '',
        [
          Validators.required,
          Validators.maxLength(30),
          this.noWhitespaceValidator,
        ],
      ],
      role: ['', [Validators.required]],
      password: ['', [Validators.minLength(6)]],
      confirmPassword: ['', [Validators.minLength(6)]],
      status: [true, [Validators.required]],
      //   sendEmail: [true, [Validators.required]],
      //idHeadquarter: ['', []],
      // locked: [false],
    });
  }

  passwordMatcher(): boolean {
    const password = this.userForm.get('password');
    const confirmPassword = this.userForm.get('confirmPassword');

    if (password.value === confirmPassword.value) {
      return true;
    }
    return false;
  }

  get f() {
    return this.userForm.controls;
  }

  openConfirmationModal() {
    if (this.userForm.valid) {
      if (!this.passwordMatcher()) {
        this.alertService.showMessage(
          '',
          'No coincide la contraseña con la contraseña de confirmación',
          MessageSeverity.error
        );
        return false;
      }

      let message = '';
      switch (this.data.action) {
        case AppConstants.OperationType.ADD:
          message = AppConstants.TitleModal.REGISTER_TITLE_USER_MODAL;
          break;
        case AppConstants.OperationType.UPDATE:
          message = AppConstants.TitleModal.EDIT_TITLE_USER_MODAL;
          break;
      }

      let dialogRef = this.dialog.open(MessageModalComponent, {
        data: {
          title: message,
          message:
            this.data.action == AppConstants.OperationType.UPDATE
              ? AppConstants.MessageModal.UPDATE_MESSAGE_USER_CONFIRM
              : AppConstants.MessageModal.REGISTER_MESSAGE_USER_CONFIRM,
          hasButton: true,
          contentButton: {
            yes: 'SI',
            no: 'CANCELAR',
          },
        },
      });

      dialogRef.afterClosed().subscribe((response) => {
        if (response.result == true) {
          if (this.data.action == AppConstants.OperationType.UPDATE) {
            let formData = new FormData();
            formData.append('userId', this.data.row.userId);
            formData.append(
              'enterpriseId',
              localStorage.getItem(AppConstants.Session.ENTERPRISE)
            ); //this.data.enterpriseId;
            formData.append('rolId', '0'); //this.userForm.value["role"];
            // formData.append('dni', this.userForm.value["documentNumber"]);
            formData.append('lasName', this.userForm.value['lastName'].trim());
            formData.append('names', this.userForm.value['names'].trim());
            formData.append('email', this.userForm.value['email'].trim());
            // formData.append('password', this.userForm.value["password"]);
            // formData.append('confirmNewPassword', this.userForm.value["confirmPassword"]);
            formData.append(
              'enabled',
              this.unparseCheckBox(this.userForm.value['status']).toString()
            );
            formData.append('sendEmail', '0'); //this.unparseCheckBox(this.userForm.value["sendEmail"]);
            formData.append('password', this.userForm.value['password']);
            // formData.append('locked', this.unparseCheckBox(this.userForm.value["locked"]));
            formData.append('userUpdate', this.sessionUserId);
            formData.append('idHeadquarter', '0'); //this.headquarterSelect;

            if (this.photoFile) {
              formData.append('photo', this.photoFile);
            }

            this.updateUser(formData);
          } else if (this.data.action == AppConstants.OperationType.ADD) {
            let formData = new FormData();
            formData.append(
              'enterpriseId',
              localStorage.getItem(AppConstants.Session.ENTERPRISE)
            ); //this.data.enterpriseId;
            formData.append(
              'idHeadquarter',
              localStorage.getItem(AppConstants.Session.HEADQUARTER)
            );
            formData.append('rolId', this.roleSelect.toString()); //this.userForm.value["role"];
            // formData.append('dni', this.userForm.value["documentNumber"]);
            formData.append('lasName', this.userForm.value['lastName'].trim());
            formData.append('names', this.userForm.value['names'].trim());
            formData.append('email', this.userForm.value['email'].trim());
            formData.append('password', this.userForm.value['password']);
            // formData.append('password', this.userForm.value["password"]);
            // formData.append('confirmNewPassword', this.userForm.value["confirmPassword"]);
            formData.append(
              'enabled',
              this.unparseCheckBox(this.userForm.value['status']).toString()
            );
            formData.append('sendEmail', '0'); //this.unparseCheckBox(this.userForm.value["sendEmail"]);
            formData.append('userCreation', this.sessionUserId);
            formData.append('idHeadquarter', '0'); //this.headquarterSelect;

            if (this.photoFile) {
              formData.append('photo', this.photoFile);
            }

            this.createUser(formData);
          }
        }
      });
    } else {
      this.userForm.markAllAsTouched();
    }
  }

  changeHeadquarter(data) {
    this.headquarterSelect = data.value;
  }

  changeRole(data) {
    this.roleSelect = data.value;
  }

  close() {
    this.dialog.closeAll();
  }

  unparseCheckBox(id: boolean) {
    if (id) return 1;
    else return 0;
  }

  createUser(formData: FormData) {
    this.spinner.show();
    this.userService.createUser(formData).subscribe(
      (response: any) => {
        // Verificar si el código de respuesta es 200 (puede venir como 'code' o 'Code')
        const responseCode = response.code || response.Code;
        if (responseCode == 200 || responseCode === 200) {
          this.alertService.showMessage(
            AppConstants.TitleModal.CREATE_USER,
            AppConstants.MessageModal.CREATE,
            MessageSeverity.success
          );
          this.data.result = true;
          this.dialogRef.close(this.data);
        } else if (response.message) {
          this.alertService.showMessage(
            AppConstants.TitleModal.CREATE_USER,
            response.message,
            MessageSeverity.error
          );
        } else {
          // Si no hay código 200 pero tampoco hay mensaje de error, asumir éxito
          this.alertService.showMessage(
            AppConstants.TitleModal.CREATE_USER,
            AppConstants.MessageModal.CREATE,
            MessageSeverity.success
          );
          this.data.result = true;
          this.dialogRef.close(this.data);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.alertService.showMessage(
          AppConstants.TitleModal.CREATE_USER,
          error.error.messages,
          MessageSeverity.error
        );
        this.spinner.hide();
      }
    );
  }

  /*
  getRoles() {
    this.spinner.show();
    let arrayRolesAdminEnterprise = [AppConstants.UserRole.AdministradorGyS, AppConstants.UserRole.UsuarioGyS, AppConstants.UserRole.UsuarioGySComercial];
    this.adminService.getEnterprises().subscribe((response) => {
      this.roles = this.isAdminGys == true ? response : response.filter(f => !arrayRolesAdminEnterprise.includes(f.rolId));
      if(this.data.action == AppConstants.OperationType.ADD){
        this.userForm.controls['role'].setValue('');
      }else{
        this.userForm.controls['role'].setValue(this.roles.length > 0 ? this.data.row.rolId : '');
      }

      if (this.data.action != AppConstants.OperationType.UPDATE)
        this.spinner.hide();
    },
      (error: HttpErrorResponse) => {
        this.spinner.hide();
      });
  }
*/

  clearFields() {
    this.userForm.controls['email'].setValue('');
    this.userForm.controls['names'].setValue('');
    this.userForm.controls['lastName'].setValue('');
    //this.userForm.controls['role'].setValue('');
    this.userForm.controls['password'].setValue('');
    this.userForm.controls['confirmPassword'].setValue('');
    this.userForm.controls['status'].setValue(true);
    // this.userForm.controls['sendEmail'].setValue(false);
    // this.userForm.controls['locked'].setValue(false);
  }

  setValues() {
    // console.log('usuario', this.data.row);
    this.clearFields();
    if (this.data.action == AppConstants.OperationType.UPDATE) {
      this.spinner.show();
      this.userService.getUserById(this.data.row.userId).subscribe(
        (response) => {
          this.userForm.patchValue({
            // documentNumber: this.data.row.dni,
            email: response.username,
            names: response.names,
            lastName: response.lasName,
            role: 0, //response.rolId,
            // password: '******',
            // confirmPassword: '******',
            status: response.enabled,
            /// sendEmail: 0response.sendEmail,
            // idHeadquarter: response.idHeadquarter
            // locked: response.locked
          });
          this.headquarterSelect = !response.idHeadquarter
            ? 0
            : response.idHeadquarter;
          this.photoPreview = response.photo; // Traemos la foto
          this.spinner.hide();
        },
        (error: HttpErrorResponse) => {
          this.spinner.hide();
        }
      );
    }
  }

  updateUser(formData: FormData) {
    this.spinner.show();
    this.userService.updateUser(formData).subscribe(
      (response: any) => {
        // Verificar si el código de respuesta es 200 (puede venir como 'code' o 'Code')
        const responseCode = response.code || response.Code;
        if (responseCode == 200 || responseCode === 200) {
          this.alertService.showMessage(
            AppConstants.TitleModal.UPDATE_USER,
            AppConstants.MessageModal.UPDATE_USER,
            MessageSeverity.success
          );
          this.data.result = true;
          if(+this.data.row.userId == +localStorage.getItem(AppConstants.Session.USERID)){
            localStorage.setItem(
              AppConstants.Session.USER,
              this.userForm.get('names').value +
                ' ' +
                this.userForm.get('lastName').value
            );
            localStorage.setItem(
              AppConstants.Session.PHOTO,
              this.photoPreview.toString()
            );
            window.location.reload();
          }
          this.dialogRef.close(this.data);
        } else if (response.message) {
          this.alertService.showMessage(
            AppConstants.TitleModal.UPDATE_USER,
            response.message,
            MessageSeverity.error
          );
        } else {
          // Si no hay código 200 pero tampoco hay mensaje de error, asumir éxito
          this.alertService.showMessage(
            AppConstants.TitleModal.UPDATE_USER,
            AppConstants.MessageModal.UPDATE_USER,
            MessageSeverity.success
          );
          this.data.result = true;
          if(+this.data.row.userId == +localStorage.getItem(AppConstants.Session.USERID)){
            localStorage.setItem(
              AppConstants.Session.USER,
              this.userForm.get('names').value +
                ' ' +
                this.userForm.get('lastName').value
            );
            localStorage.setItem(
              AppConstants.Session.PHOTO,
              this.photoPreview.toString()
            );
            window.location.reload();
          }
          this.dialogRef.close(this.data);
        }
        this.spinner.hide();
      },
      (error: HttpErrorResponse) => {
        this.alertService.showMessage(
          AppConstants.TitleModal.UPDATE_USER,
          error.error.messages,
          MessageSeverity.error
        );
        this.spinner.hide();
      }
    );
  }

  public noWhitespaceValidator(control: FormControl) {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  }

  getRoles() {
    this.spinner.show();
    this.roleService
      .getListAll(
        parseInt(localStorage.getItem(AppConstants.Session.ENTERPRISE))
      )
      .subscribe(
        (response) => {
          if (response.error == null) {
            this.roles = response.data;
            if (this.roles.length > 0) {
              this.roleSelect = this.roles[0].id;
            }
          } else {
            this.roles = [];
          }
          this.spinner.hide();
        },
        (error: HttpErrorResponse) => {
          this.roles = [];
          this.spinner.hide();
        }
      );
  }

  //FOTO DE PERFIL
  handleFileInput(event: Event) {
    const file = (event.target as HTMLInputElement).files[0];
    if (file) {
      this.photoFile = file;
      // console.log(this.photoFile);

      // Actualizar la vista para mostrar la nueva foto
      const reader = new FileReader();
      reader.onload = (e) => (this.photoPreview = reader.result as string);
      reader.readAsDataURL(file);
    }
  }

  //ELIMINAR FOTO
  deletePhoto() {
    const dialogRef = this.dialog.open(MessageModalComponent, {
      width: '250px',
      data: {
        title: AppConstants.TitleModal.DELETE_PROFILE_PHOTO,
        message:
          AppConstants.MessageModal
            .ARE_YOU_SURE_YOU_WANT_TO_DELETE_PROFILE_PHOTO,
        hasButton: true,
        contentButton: {
          yes: 'SI',
          no: 'CANCELAR',
        },
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result.result == true) {
        fetch('../../../../../../assets/images/user-noimage.png')
          .then(response => response.blob())
          .then(blob => {
            this.photoFile = new File([blob], 'user-noimage.png', { type: 'image/png' });
            this.photoPreview = '../../../../../../assets/images/user-noimage.png';
          });
      }
    });
  }

  //TABLA DE PERMISOS ASIGNADOS -------------------------------------------------------------------------------------------
  list() {
    this.spinner.show();
    var data = {
      Enterprise: +localStorage.getItem(AppConstants.Session.ENTERPRISE),
    };

    this.enterpriseService
      .getValidateMasterEnterprise(data)
      .subscribe((response) => {
        this.userService
          .getUserEnterprisesHeadquarters(this.data.row.userId)
          .subscribe(
            (response2) => {
              var dataList = response2;
              if (response.code != 200) {
                dataList = response2.filter(
                  (f) => f.idEnterprise == data.Enterprise
                );
              }
              // console.log('list', dataList);
              this.dataSource.data = dataList;
              this.spinner.hide();
            },
            (error: HttpErrorResponse) => {
              this.spinner.hide();
            }
          );
      });
  }

  add() {
    let dialogRef = this.dialog.open(UserNewAssingModalComponent, {
      data: {
        action: AppConstants.OperationType.ADD,
        title: AppConstants.TitleModal.TITLE_USER_NEW_ASSING_MODAL,
        idUser: this.data.row.userId,
        color: this.data.color,
        colorFont: this.data.colorFont,
      },
      width: '500px',
      hasBackdrop: true,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response.result == true) {
        this.list();
      }
    });
  }

  delete(element) {
    let dialogRef = this.dialog.open(MessageModalComponent, {
      data: {
        title: AppConstants.TitleModal.DELETE_TITLE_USER_ASSING_CONFIRM,
        message: `${AppConstants.MessageModal.DELETE_USER_ASSIGN_CONFIRMATION_MESSAGE1}`,
        hasButton: true,
        contentButton: {
          yes: 'SI',
          no: 'CANCELAR',
        },
      },
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response.result == true) {
        this.deleteUser(element.id);
      }
    });
  }

  deleteUser(enterpriseId: number) {
    this.spinner.show();
    var data = {
      id: enterpriseId,
      AuditUpdateUser: localStorage.getItem(AppConstants.Session.USERID),
    };

    this.userService.deleteEnterpriseHeadquarter(data).subscribe(
      (response) => {
        this.spinner.hide();
        this.alertService.showMessage(
          AppConstants.TitleModal.DELETE_USER_ASSIGN,
          AppConstants.MessageModal.DELETE,
          MessageSeverity.success
        );
        this.list();
      },
      (error: HttpErrorResponse) => {
        this.alertService.showMessage(
          AppConstants.TitleModal.DELETE_USER_ASSIGN,
          error.error.messages,
          MessageSeverity.error
        );
        this.spinner.hide();
      }
    );
  }

  openEditModal(item) {
    let dialogRef = this.dialog.open(UserNewAssingModalComponent, {
      data: {
        action: AppConstants.OperationType.UPDATE,
        title: AppConstants.TitleModal.TITLE_USER_NEW_ASSING_MODAL,
        idUser: this.data.row.userId,
        color: this.data.color,
        obj: item,
        colorFont: this.data.colorFont,
      },
      width: '500px',
      hasBackdrop: true,
    });

    dialogRef.afterClosed().subscribe((response) => {
      if (response.result == true) {
        this.list();
      }
    });
  }
}
